import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

const LoaderStyle = makeStyles()((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}))

export default LoaderStyle
